import { CoreRestCRUDService } from '../coreCommon/common/rest/CoreRestCRUDService';
import { IInvitationLinkModel } from './IInvitationLinkModel';
import { IInvitationLinkService } from './IInvitationLinkService';
import { IJoinByInvitation } from './IJoinByInvitation';
import { IProjectInvitationGet } from './IProjectInvitationGet';

export class RestInvitationLinksService
  extends CoreRestCRUDService<IInvitationLinkModel, IProjectInvitationGet>
  implements IInvitationLinkService
{
  getByAddress = async (address: string) => (await this.request().url(`${this.getEndpoint()
    }/address/${address}`).get().res().catch(this.handleError)).json()

  removeByInvitation = async (invitationId: string) => (await this.request().url(`${this.getEndpoint()
    }/leave`).options({ keepalive: true}).post({ invitationId }).res().catch(this.handleError)).json()

  getMyJoiningInProject = async (projectId: string) => (await this.request().url(`${this.getEndpoint()
    }/project/${projectId}/myJoining`).get().res().catch(this.handleError)).json()

  joinByInvitation = async (args: IJoinByInvitation) => (await this.request().url(`${this.getEndpoint()
    }/join`).options({ keepalive: true }).post(args).res().catch(this.handleError)).json()


  getListByProject = async (projectId: string) => (await this.request().url(`${this.getEndpoint()
    }/list/${projectId}`).get().res().catch(this.handleError)).json()

  getEndpoint(): string {
    const url = this.config.url.api.public;
    return `${url}/invitation`;
  }
}
